function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, DialogContent, Stack, Typography } from '@mui/material';
import { GorillaDialog } from '@procom-labs/atoms';
import { gtmEvents, useAppReloadRequired } from '@procom-labs/common';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { ModalCloseButton } from '../modal-close-button';
export var NewAppVersionPrompt = function() {
    var t = useTranslation('main').t;
    var sendDataToGTM = useGTMDispatch();
    var _useState = _sliced_to_array(useState(false), 2), isPostponed = _useState[0], setIsPostponed = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), open = _useState1[0], setOpen = _useState1[1];
    var isReloadRequired = useAppReloadRequired().isReloadRequired;
    var handleLaterBtnClick = function(event, reason) {
        if (reason && reason === 'backdropClick') return;
        sendDataToGTM({
            eventName: gtmEvents.PostponeReceivingNewBuildNumber,
            message: 'User selected update app later'
        });
        setOpen(false);
        setIsPostponed(true);
    };
    var handleConfirmModal = function() {
        setOpen(false);
        window.location.reload();
    };
    useEffect(function() {
        if (isReloadRequired && !isPostponed) {
            sendDataToGTM({
                eventName: gtmEvents.OpenReloadingDialogForNewBuildNumber,
                message: 'Modal was opened!'
            });
            setOpen(true);
        }
    }, [
        isPostponed,
        isReloadRequired,
        sendDataToGTM
    ]);
    return /*#__PURE__*/ _jsxs(GorillaDialog, {
        isLightMode: true,
        open: open,
        onClose: handleLaterBtnClick,
        disableEscapeKeyDown: true,
        maxWidth: "xs",
        sx: {
            mt: {
                xs: 5
            }
        },
        PaperProps: {
            sx: {
                paddingY: {
                    xs: 3.5,
                    lg: 6.5
                },
                paddingX: {
                    xs: 2.5,
                    lg: 5
                }
            }
        },
        children: [
            /*#__PURE__*/ _jsx(ModalCloseButton, {
                id: "close-reload-app-modal-btn",
                handleClose: handleLaterBtnClick
            }),
            /*#__PURE__*/ _jsx(DialogContent, {
                sx: {
                    padding: 0,
                    mb: 4,
                    overflowY: 'revert'
                },
                children: /*#__PURE__*/ _jsxs(Stack, {
                    direction: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            variant: "h22Bold800",
                            gutterBottom: true,
                            component: "p",
                            sx: {
                                textAlign: 'center'
                            },
                            children: [
                                t('common.appVersionPrompt.title'),
                                ' '
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "body1",
                            gutterBottom: true,
                            component: "p",
                            sx: {
                                textAlign: 'center',
                                whiteSpace: 'pre-line'
                            },
                            children: t('common.appVersionPrompt.note')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(DialogActions, {
                sx: {
                    justifyContent: 'center'
                },
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        id: "update-app-later-btn",
                        variant: "outlined",
                        onClick: handleLaterBtnClick,
                        children: t('common.appVersionPrompt.later')
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        color: "secondary",
                        id: "update-app-now-btn",
                        variant: "contained",
                        onClick: handleConfirmModal,
                        children: t('common.appVersionPrompt.confirm')
                    })
                ]
            })
        ]
    });
};
